// AI-CONTEXT: See docs/features/participation-ladder.md

// Progressive income tax: each bracket taxes the slice of income between the
// previous ceiling and its own `upTo` at the bracket `rate`.
const computeIncomeTax = (grossIncome, brackets = []) => {
    const income = Math.max(0, Number(grossIncome) || 0)
    let tax = 0
    let lower = 0

    for (const { upTo, rate } of brackets) {
        if (income <= lower) break
        const taxable = Math.min(income, upTo) - lower
        tax += taxable * rate
        lower = upTo
    }

    return tax
}

export default computeIncomeTax
